<div class="heading-container">
  <h3>Operations Tracking</h3> 
  <div *ngIf="isAdmin" class="button-div">
    <button mat-button class="primary-button" (click)="openBulkRecreateDialog()" [disabled]="true | timeCheck">Bulk Recreate Orders</button>
  </div>
</div>
<div class="tabs-container">
  <div class="tab" *ngFor="let tab of trackingTabs" (click)="setActiveTab(tab.route)">
    <div [class]="tab.name === activeTab ? 'tab-text-highlight' : 'tab-text'">
      <p [class]="tab.name === activeTab ? 'highlight' : ''">{{ tab.name }}</p>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
